define('businessServices/signup/signupCookieStore',[
    'common/time/date',
    'cookie'
], () => {
    return function() {
        let self = this;
        const AFFILIATE_URL_COOKIE = 'affiliate_url';
        const HUBSPOT_UTK_COOKIE = 'hubspotutk';
        const PATLIVE_GCLID_COOKIE = 'patlive_gclid';
        const PATLIVE_UTM_SOURCE_COOKIE = 'patlive_utm_source';
        const PATLIVE_UTM_MEDIUM_COOKIE = 'patlive_utm_medium';
        const PATLIVE_UTM_CAMPAIGN_COOKIE = 'patlive_utm_campaign';
        const PATLIVE_UTM_TERM_COOKIE = 'patlive_utm_term';
        const PATLIVE_UTM_CONTENT_COOKIE = 'patlive_utm_content';

        const _cookieOptions = {
            path: '/'
        };

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const _isEmptyCookieValue = (value) => !value || value === '{}' || value === '""' || value === 'null';

        // Reading directly from document.cookie to bypass global flag $.cookie.json
        // which is set to true by other modules; we need raw string values here
        const _getRawCookieValue = (cookieName) => {
            const cookies = document.cookie.split('; ');

            for (let i = 0; i < cookies.length; i++) {
                const parts = cookies[i].split('=');
                const name = decodeURIComponent(parts.shift()).trim();
                if (name !== cookieName) {
                    continue;
                }

                const decodedValue = decodeURIComponent(parts.join('='));
                if (!_isEmptyCookieValue(decodedValue)) {
                    return decodedValue;
                }
            }

            return null;
        };

        self.clear = () => {
            [
                AFFILIATE_URL_COOKIE,
                PATLIVE_GCLID_COOKIE,
                PATLIVE_UTM_SOURCE_COOKIE,
                PATLIVE_UTM_MEDIUM_COOKIE,
                PATLIVE_UTM_CAMPAIGN_COOKIE,
                PATLIVE_UTM_TERM_COOKIE,
                PATLIVE_UTM_CONTENT_COOKIE
            ].forEach((cookieName) => $.cookie(cookieName, '', $.extend({}, _cookieOptions, { expires: -1 })));
        };

        self.get = () => {
            return _promiseFactory.defer((deferredObject) => {
                const affiliateUrl = _getRawCookieValue(AFFILIATE_URL_COOKIE);
                const hubSpotUtk = _getRawCookieValue(HUBSPOT_UTK_COOKIE);
                const googleClickId = _getRawCookieValue(PATLIVE_GCLID_COOKIE);
                const utmSource = _getRawCookieValue(PATLIVE_UTM_SOURCE_COOKIE);
                const utmMedium = _getRawCookieValue(PATLIVE_UTM_MEDIUM_COOKIE);
                const utmCampaign = _getRawCookieValue(PATLIVE_UTM_CAMPAIGN_COOKIE);
                const utmTerm = _getRawCookieValue(PATLIVE_UTM_TERM_COOKIE);
                const utmContent = _getRawCookieValue(PATLIVE_UTM_CONTENT_COOKIE);

                deferredObject.resolve({
                    affiliateUrl,
                    hubSpotUtk,
                    googleClickId,
                    utmSource,
                    utmMedium,
                    utmCampaign,
                    utmTerm,
                    utmContent
                });
            });
        };

        self.init = () => {
            _initialize();
        };

        const _initialize = () => {

        };
    };
});

